import PropTypes from 'prop-types';

export default PropTypes.oneOf([
  'thumbnail',
  'thumbnailTracked',
  'thumbnailNoImage',
]);
